import { JSX } from 'react';
import { useTranslation } from 'react-i18next';
import { useLayout } from '../hooks/layout.hook';
import { useNavigation } from '../hooks/navigation.hook';

export function DescriptionScreen(): JSX.Element {
  const { navigate } = useNavigation();
  const { t } = useTranslation();

  useLayout(
    () => ({
      hideFooter: true,
      backButton: true,
      title: t('Description'),
    }),
    [t],
  );

  return (
    <div className="space-y-4">
      {sections.map((s, i) =>
        Array.isArray(s) ? (
          <div className="grid grid-cols-3 gap-4">
            {s.map((ig, j) => (
              <img key={j} src={ig} className="w-full h-auto object-cover rounded-lg" alt="" />
            ))}
          </div>
        ) : (
          <div key={i} className="text-base-content/70 hyphens-auto">
            {t(s)}
          </div>
        ),
      )}

      <button className="btn btn-primary btn-lg w-full" onClick={() => navigate('/auth')}>
        {t('Get started')}
      </button>
    </div>
  );
}

const sections = [
  'Virtus helps you to live your lofty ideals in your everyday life. Vague resolutions become clear, measurable goals: you decide what you want to work on—such as prayer, practicing virtues, or devotion to your neighbor—and record what you have actually achieved each day. Clear graphics show you your progress and motivate you to keep going, even when things get difficult.',
  ['/screenshots/habits.jpeg', '/screenshots/statistic-boolean.jpeg', '/screenshots/statistic-value.jpeg'],
  'The app builds on the proven practice of great spiritual masters such as Ignatius of Loyola and Teresa of Avila: small, concrete steps and honest reflection. In this way, you gradually develop good habits that will have a lasting impact on your life—not only in your relationships with others, but above all in your relationship with God.',
  "So that you are not alone on your journey, you can involve an accountability partner in Virtus. Share your resolutions, encourage each other, and create a friendly commitment in the pursuit of holiness. Virtus makes your path of following Christ visible, structured, and suitable for everyday life—leading you to the best version of yourself through God's grace and the help of the Blessed Mother.",
];
